<template>
  <div>
    <slot :open="open">
      <md-button :class="`md-${buttonType} md-sm`" @click="open">{{ buttonLabel }}</md-button>
    </slot>
    <el-drawer
      :visible.sync="showDrawer"
      :show-close="false"
      :withHeader="false"
      :append-to-body="true"
      @close="close"
      :modal="false"
      size="40%">
      <div class="header">
        <div style="display: flex; align-items: center">
          <a href="javascript:" v-if="showBack" @click="back">
            <md-icon>keyboard_backspace</md-icon>
          </a>
          <h5>{{ title }}</h5>
        </div>
        <md-button class="md-default md-sm" @click="close">Close</md-button>
      </div>
      <div class="content">
        <template v-if="step === 1">
          <table>
            <tbody>
            <tr v-for="(component, index) in components" :key="index" class="entity-group">
              <td><p class="font-600">{{ component.label }}</p></td>
              <td><a href="javascript:" class="text-success" @click="getTrails(component.entity_type_id, component.entity_id)">View Logs</a></td>
            </tr>
            </tbody>
          </table>
        </template>
        <template v-else-if="step === 2">
          <table>
            <thead>
            <tr>
              <th>Date Updated</th>
              <th>Updated By</th>
              <th>Performed On</th>
              <th>Action</th>
              <th></th>
            </tr>
            </thead>
            <tbody>
              <template v-if="trails.length">
                <tr v-for="(trail, index) in trails" :key="index">
                  <td>
                    <p>{{ trail.pretty && $moment(trail.pretty.done_at).format('DD MMM YYYY') }}</p>
                    <span style="font-size: 13px">{{ trail.pretty && $moment(trail.pretty.done_at).format('h:mm a') }}</span>
                  </td>
                  <td>
                    <p>{{ trail.pretty && trail.pretty.actor }}</p>
                    <span style="font-size: 12px">{{ trail.user_type_object && trail.user_type_object.label }}</span>
                  </td>
                  <td>
                    <p>{{ trail.pretty && trail.pretty.entity_reference }}</p>
                    <span style="font-size: 13px">{{ trail.pretty && trail.pretty.entity_type }}</span>
                  </td>
                  <td><p>{{ trail.pretty && trail.pretty.action }}</p></td>
                  <td><a href="javascript:" class="text-success" @click="getRecord(trail.id)">View Log</a></td>
                </tr>
              </template>
             <template v-else>
               <tr>
                 <td colspan="4">
                   <div style="text-align: center;height: 60px;padding-top: 15px">
                     No data to display
                   </div>
                 </td>
               </tr>
             </template>
            </tbody>
          </table>
        </template>
        <template v-else-if="step === 3 && record">
          <table style="margin-bottom: 20px">
            <tbody>
            <tr>
              <td><p class="font-600">Date Updated:</p></td>
              <td><p>{{ $moment(record.pretty.done_at).format('DD MMM YYYY - h:mm a')}}</p></td>
            </tr>
            <tr>
              <td><p class="font-600">Updated By:</p></td>
              <td>
                <p>{{ record.pretty.actor }}</p>
                <span style="font-size: 13px">{{ record.pretty.actor_email }}</span>
              </td>
            </tr>
            <tr>
              <td><p class="font-600">Performed On:</p></td>
              <td>
                <p>{{ record.pretty.entity_type }} - {{ record.pretty.entity_reference }} </p>
              </td>
            </tr>
            <tr>
              <td><p class="font-600">Action:</p></td>
              <td><p>{{ record.pretty.action }}</p></td>
            </tr>
            </tbody>
          </table>
          <table class="bordered data">
            <thead>
            <tr>
              <th>Property</th>
              <th>Previous Data</th>
              <th>Current Data</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(param, index) in getRecordParams()" :key="index">
              <td><p style="text-transform: capitalize; opacity: 0.74">{{ param.replaceAll("_", " ") }}</p></td>
              <td><p>{{ record.pretty.previous_data[param] || "-" }}</p></td>
              <td style="text-align: left">
                <a v-if="param.toLowerCase()  === 'url'" :href="record.pretty.current_data[param]" target="_blank">{{ record.pretty.current_data[param] || "-" }}</a>
                <p v-else>{{ record.pretty.current_data[param] || "-" }}</p>
              </td>
            </tr>
            </tbody>
          </table>
        </template>
      </div>
      <div v-if="step === 2" class="footer">
        <p>Result {{from + 1}} to {{to}} of {{total}} </p>
        <pagination
          class="pagination-no-border pagination-success"
          v-model="currentPage"
          :per-page="pagination.perPage"
          :total="total"
        ></pagination>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import { Drawer } from "element-ui";
import { Pagination } from "@/components";
import auditTrailEntities from "@/components/AuditTrail/auditTrailEntities";

export default {
  name: "AuditTrailEntity",
  props: {
    title: {
      type: String,
      default: "Audit Trail"
    },
    buttonLabel: {
      type: String,
      default: "View Audit Trail"
    },
    buttonType: {
      type: String,
      default: "info"
    },
    entity: {
      type: String
    },
    entityId: {
      type: Number,
      default: null
    },
    recordId: {
      type: Number,
      default: null
    },
  },
  components: {
    ElDrawer: Drawer,
    Pagination
  },
  data() {
    return {
      showDrawer: false,
      step: 0,
      components: [],
      trails: [],
      trailsEntityTypeId: null,
      trailsEntityId: null,
      record: null,
      currentPage: 1,
      pagination: {
        perPage: 20,
        total: 0
      }
    }
  },
  computed: {
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },

    from() {
      return this.pagination.perPage * (this.currentPage - 1);
    },

    total() {
      return this.pagination.total;
    },

    showBack() {
      if (this.step <= 1) {
        return false
      }

      if (this.components.length === 1 && this.step === 2) {
        return false
      }

      return !this.recordId;
    }
  },
  watch: {
    showDrawer() {
      if(this.showDrawer) {
         if (this.recordId) {
          this.getRecord(this.recordId);
        } else {
          this.getComponents();
        }
      }
    },
    currentPage() {
      if(this.currentPage === 1) {
        return;
      }
      this.getTrails();
    }
  },
  methods: {
    open() {
      const entityTypeId = this.entity && auditTrailEntities[this.entity]
      if (!entityTypeId && !this.recordId) {
        this.notification("No audit trail for this entity", "info", "info")
        return
      }

      this.showDrawer = true;
    },
    back() {
      this.step -= 1;
      if (this.step === 1) {
        this.trails = [];
        this.trailsEntityTypeId = null;
        this.trailsEntityId = null;
        this.currentPage = 1;
        this.pagination.total = 0;
      }

      if (this.step === 2) {
        this.record = null
      }
    },
    close() {
      this.showDrawer = false;
      this.step = 0;
      this.components = [];
      this.trails = [];
      this.record = {}
      this.currentPage = 1;
      this.pagination.total = 0;
    },
    getComponents() {
      const entityTypeId = this.entity && auditTrailEntities[this.entity]
      if (!entityTypeId) {
        this.notification("No audit trail for this entity", "info", "info")
        return
      }

      const params = `&entity_type_id=${entityTypeId}&entity_id=${this.entityId}`;
      this.$http.post("audit/trail/components", { method: "GET", params }).then(
        response => {
          if (response.data) {
            if (response.data.error) {
              this._handleErrors(response.data);
            } else {
              this.components = response.data;

              if (this.components.length === 1) {
                const { entity_id, entity_type_id } = response.data[0]
                this.getTrails(entity_type_id, entity_id);
              } else {
                this.step = 1;
              }
            }
          } else {
            this.notification(
              "An unknown error occurred",
              "pan_tool",
              "danger"
            );
          }
        },
        error => {
          this.notification(error.message, "pan_tool", "danger");
        }
      );
    },

    getTrails(entityTypeId, entityId) {
      if (entityTypeId && entityId) {
        this.trailsEntityTypeId = entityTypeId;
        this.trailsEntityId = entityId;
      }
      if (!this.trailsEntityTypeId && !this.trailsEntityId) {
        this.notification("Error getting data", "error", "danger")
      }

      const filters = [
        { field: this.entity === 'admin' ? 'user_type_id' : "entity_type_id", value: this.trailsEntityTypeId },
        { field: this.entity === 'admin' ? 'user_id' : "entity_id", value: this.trailsEntityId },
      ]
      const params = `&filters=${JSON.stringify(filters)}&page=${this.currentPage}&order_by=done_at&is_asc=0`;
      this.$http.post("audit/trail", { method: "GET", params }).then(
        response => {
          if (response.data) {
            if (response.data.error) {
              this._handleErrors(response.data);
            } else {
              this.trails = response.data.list;
              if (this.trails.length === 0 && this.entity === 'admin') {
                this.getRecord(this.recordId);
              } else {
                this.pagination.total = response.data.pagination.total_count;
                this.step = 2;
              }
            }
          } else {
            this.notification(
              "An unknown error occurred",
              "pan_tool",
              "danger"
            );
          }
        },
        error => {
          this.notification(error.message, "pan_tool", "danger");
        }
      );
    },
    getRecord(recordId) {
      this.$http.post(`audit/trail/${recordId}`, { method: "GET" }).then(
        response => {
          if (response.data) {
            if (response.data.error) {
              this._handleErrors(response.data);
            } else {
              this.record = response.data;
              this.step = 3;
            }
          } else {
            this.notification(
              "An unknown error occurred",
              "pan_tool",
              "danger"
            );
          }
        },
        error => {
          this.notification(error.message, "pan_tool", "danger");
        }
      );
    },
    getRecordParams() {
      const { current_data } = this.record && this.record.pretty;
      return current_data && Object.keys(current_data)
    },

    _handleErrors(response) {
      if (response.data) {
        for (let message in response.data) {
          this.notification(response.data[message][0], "pan_tool", "danger");
        }
      } else {
        if(response.code !== 'ACCESS_DENIED') {
          this.notification(response.message, "pan_tool", "danger");
        }
      }
    },

    notification(message, icon, color) {
      this.$notify({
        message: message,
        icon: icon,
        horizontalAlign: "right",
        verticalAlign: "top",
        type: color
      });
    },
  }
}
</script>

<style lang="scss">
.el-drawer__wrapper {
  z-index: 9999 !important;

  .el-drawer.rtl {
    direction: ltr;
  }

  .el-drawer__body {
    padding: 20px;
    overflow: hidden;

    .header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      grid-gap: 30px;
      margin-bottom: 20px;
      min-height: 40px;

      h5 {
        margin: 0;
        font-weight: 500;
      }

      a {
        font-weight: 500;
        font-size: 12.5px;
        text-transform: uppercase;
        margin-right: 12px;
      }
    }

    .content {
      height: calc(100vh - 140px);
      overflow-y: auto;
    }
    table {
      width: 100%;
      border-radius: 8px;
      border: 1px solid #a2a9b0;
      border-spacing: 0;
      animation: fadeIn 1s;

      thead tr {
        th {
          text-align: left;
          font-weight: 600;
          font-size: 13px;
          color: #000;
          padding: 5px 8px;
          border-bottom: 1px solid #a2a9b0;
        }
      }

      tbody tr {
        &:not(:last-child) td {
          border-bottom: 1px solid #a2a9b0;
        }

        td {
          padding: 5px 8px;
          min-width: 80px;
          vertical-align: top;

          &:last-child {
            text-align: right;
          }
        }

        p {
          font-size: 12px;
          font-weight: 400;
          margin: 0;
          color: #1B1B1B;

          &.font-500 {
            font-weight: 500;
          }

          &.font-600 {
            font-weight: 600;
          }
        }

        a {
          font-weight: 500;
          color: #4caf50;
          font-size: 12px;
        }
      }

      &.bordered {
        th:not(:last-child),
        td:not(:last-child) {
          border-right: 1px solid #a2a9b0;
        }
      }

      &.data {
        td:not(:first-child) {
          width: 36%;
        }

        a,
        p {
          max-width: 150px;
          text-overflow: ellipsis;
          overflow: hidden;
        }

        a, a:hover {
          text-decoration: underline;
          display: inline-block;
        }
      }
    }

    .footer {
      height: 55px;
      display: flex;
      flex-direction: row-reverse;
      justify-content: space-between;
      align-items: center;

      p {
        margin-right: 10px !important;
      }

      ul, p {
        margin: 0 !important;
      }
    }
  }
}

@keyframes fadeIn {
  0% { opacity: 0; }
  100% { opacity: 1; }
}
</style>
